/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import type { HTMLAttributes } from 'react';

import { pxToRem } from '@/Client/Styles/pxToRem';
import { MODAL_COLORS } from './ModalStyleLib';

const DANGER_CALLOUT_STYLE = css`
  label: DANGER_CALLOUT_STYLE;
  margin-top: 17px;
  width: 100%;
  border-radius: 5px;
  background: ${MODAL_COLORS.dangerBackground};
  padding: 17px 22px;
  font-family: CircularXX, sans-serif;
  font-size: ${pxToRem(14)};
  font-style: normal;
  font-weight: 400;
  line-height: 1.429;
  letter-spacing: 0.28px;
  color: ${MODAL_COLORS.text};
`;

export const ModalDangerCallout = (props: HTMLAttributes<HTMLDivElement>) => <div css={DANGER_CALLOUT_STYLE} {...props} />;
